// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueMDCAdapter from 'vue-mdc-adapter'
import * as VueGoogleMaps from 'vue2-google-maps'
import './scss/theme.scss'

const instance = axios.create({
    baseURL: API_URL,
    timeout: 1000,
});
Vue.use(VueMDCAdapter)
Vue.config.productionTip = process.env.NODE_ENV === 'production'
Vue.use(VueGoogleMaps, {
    load: {
        // Google API key
        key: 'AIzaSyA3pZZ-rQg_jzpu4n8UAH8YYFKX0AyI32A'
    }
})
Vue.component('google-map', VueGoogleMaps.Map)
Vue.component('google-marker', VueGoogleMaps.Marker)

/* eslint-disable no-new */
var vm = new Vue({
    el: '#app',
    methods: {
        async onAccept() {
            instance.post('/v1/contact/', {
                first_name: this.contact.first_name,
                last_name: this.contact.last_name,
                phone_number: this.contact.phone_number,
                contact_time: this.contact.contact_time,
                message: this.contact.message,
                email: this.contact.email
            }).then(function(response) {
                this.$refs.snackbar.show({
                    message: response.data.msg
                })
            }).catch(function(error) {
                console.log(error.response)
                this.$refs.snackbar.show({
                    message: error.response.data.description
                })
            })

        },
        onDecline() {},
        onValidate({ accept }) {
            console.log("this is my validation");
            let form = document.getElementById("contactForm");
            if (form.reportValidity()) {
                accept();
            }
        }
    },
    data: {
        open: false,
        contact: {
            first_name: '',
            last_name: '',
            phone_number: '',
            email: '',
            message: '',
            contact_time: ''
        },
        markers: [{
            position: {
                lat: 45.6369239,
                lng:-122.6696005
            }
        }]
    }
})



// WEBPACK FOOTER //
// ./src/main.js